import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root',
})
export class TermService {
  public url: string;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  getTerms(token): Observable<any> {
    let params = `authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/term/list?page=1`, params, { headers: headers });
  }

  getTermsByCompany(token, id): Observable<any> {
    let params = `authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/term/listbycompany/${id}?page=1`, params, { headers: headers });
  }

  getTermsByUser(token, id): Observable<any> {
    let params = `authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/term/listbyuser/${id}?page=1`, params, { headers: headers });
  }

  newTerm(token, term): Observable<any> {
    let json = JSON.stringify(term);
    json = encodeURIComponent(json);
    let params = `json=${json}&authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/term/new?page=1`, params, { headers: headers });
  }

  editTerm(token, id, term): Observable<any> {
    let json = JSON.stringify(term);
    json = encodeURIComponent(json);
    let params = `json=${json}&authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/term/edit/${id}?page=1`, params, { headers: headers });
  }

  delete(token, id): Observable<any> {
    let params = `authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/term/remove/${id}?page=1`, params, { headers: headers });
  }

  getTerm(token, id): Observable<any> {
    let params = `authorization=${token}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    return this._http.post<any>(`${this.url}/term/detail/${id}?page=1`, params, { headers: headers });
  }
}
